import React, {useEffect} from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import './App.css';
import Routes from './routes'
import {BRAND_BLUE, BRAND_TURQUOISE} from './theme';
import {useDispatch} from 'react-redux';
import {logout} from './redux/actions';
import {removeToken} from './auth';

const theme = createTheme({
    palette: {
        secondary: {
            main: BRAND_TURQUOISE
        },
        primary: {
            main: BRAND_BLUE
        }
    },
    typography: {
        fontFamily: ['"Inter"', 'sans-serif'].join(',')
    }
});


function App() {
    const dispatch = useDispatch();

    useEffect(() => {
        const handler = () => { removeToken(); dispatch(logout()); };
        window.addEventListener('api:unauthorized', handler);
        return () => window.removeEventListener('api:unauthorized', handler);
    }, [dispatch]);

    return (
        <ThemeProvider theme={theme}>
            <Routes/>
        </ThemeProvider>
    );
}

export default App;
